import { Results } from '@interfaces/results.interface';

export type RatesSummaryResultState = Results;

export const initialState: RatesSummaryResultState = {} as Results;
